import React, { useEffect, useMemo } from "react";
import { usePage } from "@inertiajs/inertia-react";
import { useAtom } from "jotai";
import { focusAtom } from "jotai-optics";
import { reportQuestionsAtom } from "@/Stores";
import { LabeledInputCalculatable } from "@/Components/LabledInputCalculatable";

export function InputTypeCalculateForm({ question, values = null }) {
  const errors = usePage().props?.errors || {};
  const errorBag = `reportQuestion.${question.id}`;

  const inputAtom = useMemo(
    () => focusAtom(reportQuestionsAtom, (optic) => optic.prop(question.id)),
    [question],
  );
  const [payload, setPayload] = useAtom(inputAtom);

  const input = question.inputs?.[0] || null;

  useEffect(() => {
    if (!input) return;

    setPayload({
      answers: [
        {
          question_input_id: input.id,
          value: values?.[0]?.value?.toString() || null,
        },
      ],
    });
  }, []);

  const handleFormUpdate = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({
      ...prev,
      answers: [{ question_input_id: input.id, [name]: value }],
    }));
  };

  if (!input) return null;

  return (
    <LabeledInputCalculatable
      name="value"
      title={`${input.label}*`}
      placeholder=""
      className="mb-4"
      value={payload?.answers?.[0]?.value || ""}
      onChange={handleFormUpdate}
      id={input.id}
      error={
        errors?.[errorBag]?.["values.0.value"] ||
        errors?.[`${errorBag}.values.0.value`]
      }
      unit={input.unit}
    />
  );
}
